import React from "react";
import { Navigate } from "react-router-dom";
import { usePermission } from "../hooks/usePermission";
import { NoAccess } from "./shared/NoAccess";

interface ProtectedRouteProps {
  children: React.ReactNode;
  action: "manage" | "create" | "read" | "update" | "delete" | "execute" | "publish" | "configure" | "import" | "export";
  subject:
  | "all"
  | "organization"
  | "workflow"
  | "campaign"
  | "channel"
  | "cdp"
  | "integration"
  | "conversation"
  | "user"
  | "role"
  | "analytics"
  | "billing"
  | "apiKey"
  | "webhook"
  | "whatsapp-onboarding";
  fallback?: React.ReactNode;
  redirectTo?: string;
  showNoAccess?: boolean; // If true, show NoAccess screen instead of redirecting
}

export const ProtectedRoute: React.FC<ProtectedRouteProps> = ({
  children,
  action,
  subject,
  fallback,
  redirectTo = "/",
  showNoAccess = true, // Default to showing NoAccess screen
}) => {
  const { can } = usePermission();

  if (!can(action, subject)) {
    if (fallback) {
      return <>{fallback}</>;
    }

    // Show NoAccess screen by default, or redirect if explicitly disabled
    if (showNoAccess) {
      // Format subject name for display (e.g., "workflow" -> "workflows")
      const subjectName = subject === "all" ? "this page" : `${subject}s`;
      return (
        <NoAccess
          subject={subjectName}
          action={action}
        />
      );
    }

    return <Navigate to={redirectTo} replace />;
  }

  return <>{children}</>;
};

